import { CalendarClock, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import type { RenewalReminderState } from "@/hooks/subscription/useRenewalReminder";

interface RenewalBannerProps {
  reminder: RenewalReminderState;
}

export function RenewalBanner({ reminder }: RenewalBannerProps) {
  const navigate = useNavigate();
  const { audience, expiryLabel } = reminder;

  if (!reminder.isBannerVisible) return null;

  return (
    <div
      role="status"
      className="mb-4 flex flex-col gap-3 rounded-xl border border-warning/40 bg-warning/10 p-3 sm:mb-6 sm:flex-row sm:items-center sm:p-4"
    >
      <div className="flex min-w-0 flex-1 items-start gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-card">
          <CalendarClock className="h-5 w-5 text-warning" />
        </div>
        <div className="min-w-0 space-y-0.5">
          <p className="text-sm font-semibold text-foreground">
            Your FirstRep portal subscription ends {expiryLabel}.
          </p>
          <p className="text-xs text-muted-foreground sm:text-sm">
            Renew now or let the right person know, so access isn't interrupted.
          </p>
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-1 self-end sm:self-auto">
        {audience === "payer" ? (
          <Button
            size="sm"
            onClick={() => navigate("/settings?section=subscription")}
          >
            Renew now
          </Button>
        ) : (
          <Button size="sm" onClick={reminder.openModal}>
            Send reminder
          </Button>
        )}
        <Button
          variant="ghost"
          size="icon"
          aria-label="Hide until tomorrow"
          onClick={reminder.dismissBanner}
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
